module.exports = __webpack_public_path__ + "static/media/011.eb650d42.jpg";